import { useState } from "react";
import Loader from "../../../components/Loader/Loader";
import UserService from "../../../services/UserService";
import { IoMdCheckmark, IoMdClose } from "react-icons/io";
import "./InvitationButtons.css";

export const InvitationButtons = ({ className, invitation, invitationId, onSubmit, showText = false }) => {
	const [showLoader, setShowLoader] = useState(false);

	async function onAccept(id) {
		setShowLoader(true);
		await UserService.acceptInvitation(id);
		onSubmit?.(invitation);
		setShowLoader(false);
	}

	async function onDeny(id) {
		setShowLoader(true);
		await UserService.denyInvitation(id);
		onSubmit?.(invitation);
		setShowLoader(false);
	}

	return (
		<div className={`invitation-buttons ${className}`} data-with-texts={showText}>
			{showLoader ? (
				<Loader width={40} height={40} style={{ marginTop: '0px' }} />
			) : (
				<>
					<button type="button" className="accept-btn" onClick={(e) => onAccept(invitationId)}>
						{showText && (<span>Aceitar</span>)}
						<IoMdCheckmark />
					</button>
					<button type="button" className="deny-btn" onClick={(e) => onDeny(invitationId)}>
						{showText && (<span>Recusar</span>)}
						<IoMdClose />
					</button>
				</>
			)}
		</div>
	);
}